import { getLocale, setLocale, type Locale } from '../lib/i18n'
import { Flag } from './Icon'

/**
 * English / Puerto Rican Spanish.
 *
 * A visible toggle rather than a settings page, because the person who needs it
 * is the one who cannot read the settings page. It shows BOTH flags with the
 * inactive one dimmed, so what it does is obvious before it is pressed — a
 * single flag is ambiguous about whether it shows the current language or the
 * one you would switch to, and people get that wrong about half the time.
 *
 * Changing locale reloads. The alternative is threading a locale through every
 * component and re-rendering the tree, for a control most people press once,
 * ever; a reload is honest and costs nothing on a static bundle.
 */
export default function LanguageToggle() {
  const current = getLocale()

  const pick = (next: Locale) => {
    if (next === current) return
    setLocale(next)
    window.location.reload()
  }

  return (
    <div className="lang" role="group" aria-label="Language / Idioma">
      {(['en', 'es-PR'] as const).map((loc) => (
        <button
          key={loc}
          onClick={() => pick(loc)}
          aria-pressed={current === loc}
          aria-label={loc === 'en' ? 'English' : 'Español'}
          title={loc === 'en' ? 'English' : 'Español'}
          className={current === loc ? 'on' : ''}
        >
          <Flag locale={loc} size={22} />
        </button>
      ))}
    </div>
  )
}
